import gql from 'graphql-tag'
import { CategoryTranslateFragment } from '@/graphql/mia/fragments/categoryTranslate'
import { ReadErrorFragment } from '@/graphql/mia/fragments/readError'

export const READ_CATEGORIES_TRANSLATE = gql`
  query ReadCategoriesTranslate($categoriesTranslateInput: CategoriesTranslateInput!) {
    readCategoriesTranslate(categoriesTranslateInput: $categoriesTranslateInput) {
      data {
        ...CategoryTranslateFragment
      }
      error {
        ...ReadErrorFragment
      }
    }
  }
  ${CategoryTranslateFragment}
  ${ReadErrorFragment}
`
